import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterLocation,
  TAdvancedFilterSingle,
  TFilterLocationOptions,
} from '../../../../models/advanced-filter.model';
import { locationOperatorOptions } from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-location',
  templateUrl: './advanced-filter-location.component.html',
  styleUrls: ['./advanced-filter-location.component.scss'],
  standalone: false,
})
export class AdvancedFilterLocationComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  option: TFilterLocationOptions;
  filter: TAdvancedFilterLocation;

  advancedFilterLocationOptions = locationOperatorOptions;
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterLocation;

    this.option = this.filter.option;
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter.option = newCondition.value as TFilterLocationOptions;
    this.option = newCondition.value as TFilterLocationOptions;

    this.ppFilter.operator = newCondition.operator;
    this.ppFilter.value = newCondition.value;

    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }

  changeFieldValue(value: string): void {
    this.ppFilter.value = value;
    this.applyChanges();
  }
}
